/**
 * OFStatusDialog - Diálogo para transição de estado da OF
 * Extraído de GestaoOFs.js para melhor modularidade
 */
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../ui/dialog';
import { Button } from '../../ui/button';
import { FileText, CheckCircle, Clock, Play, Pause, Check, XCircle } from 'lucide-react';

const STATUS_CONFIG = {
  rascunho: { label: 'Rascunho', color: 'bg-stone-100 text-stone-600', icon: FileText },
  pendente: { label: 'Ready to Start', color: 'bg-blue-100 text-blue-600', icon: CheckCircle },
  aguardar_entrada: { label: 'Aguardar Entrada', color: 'bg-amber-100 text-amber-600', icon: Clock },
  em_curso: { label: 'Em Curso', color: 'bg-green-100 text-green-600', icon: Play },
  pausado: { label: 'Pausado', color: 'bg-orange-100 text-orange-600', icon: Pause },
  terminado: { label: 'Terminado', color: 'bg-emerald-100 text-emerald-600', icon: Check },
  cancelado: { label: 'Cancelado', color: 'bg-red-100 text-red-600', icon: XCircle },
};

const TRANSICOES_VALIDAS = {
  rascunho: ['pendente', 'aguardar_entrada', 'em_curso', 'cancelado'],
  pendente: ['em_curso', 'aguardar_entrada', 'cancelado'],
  aguardar_entrada: ['em_curso', 'pendente', 'cancelado'],
  em_curso: ['pausado', 'terminado', 'cancelado'],
  pausado: ['em_curso', 'terminado', 'cancelado'],
  terminado: [],
  cancelado: ['rascunho'],
};

export default function OFStatusDialog({
  open,
  onOpenChange,
  selectedOF,
  statusObservacao,
  setStatusObservacao,
  onTransitarStatus,
  loading,
  getStatusBadge,
}) {
  const handleClose = (isOpen) => {
    onOpenChange(isOpen);
  };

  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent className="max-w-md" data-testid="status-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading">Transitar Estado - {selectedOF?.numero_of}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div className="flex items-center gap-2 p-3 bg-stone-50 rounded-lg">
            <span className="text-sm text-stone-600">Estado atual:</span>
            {selectedOF && getStatusBadge(selectedOF.status)}
          </div>
          <div>
            <label className="block text-sm font-medium text-stone-700 mb-2">Transitar para:</label>
            <div className="grid grid-cols-2 gap-2">
              {selectedOF && TRANSICOES_VALIDAS[selectedOF.status]?.map((novoStatus) => {
                const config = STATUS_CONFIG[novoStatus];
                const Icon = config?.icon || FileText;
                return (
                  <Button
                    key={novoStatus}
                    variant="outline"
                    className={`justify-start ${config?.color}`}
                    onClick={() => onTransitarStatus(novoStatus)}
                    disabled={loading}
                    data-testid={`status-btn-${novoStatus}`}
                  >
                    <Icon className="h-4 w-4 mr-2" />
                    {config?.label || novoStatus}
                  </Button>
                );
              })}
            </div>
            {selectedOF && (!TRANSICOES_VALIDAS[selectedOF.status] || TRANSICOES_VALIDAS[selectedOF.status].length === 0) && (
              <p className="text-sm text-stone-500 text-center py-4">Este estado não permite transições.</p>
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
